<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <!--      <el-tabs v-model="activeName" @tab-click="handleClick">-->
      <!--        <el-tab-pane label="出售中" name="sell">-->
      <!--          <span slot="label">出售中 <el-tag size="mini">{{ productCount.sell }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--        &lt;!&ndash;        <el-tab-pane label="仓库中" name="lower">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <span slot="label">仓库中 <el-tag size="mini">{{ productCount.lower }}</el-tag></span>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </el-tab-pane>&ndash;&gt;-->
      <!--        &lt;!&ndash;        <el-tab-pane label="回收站" name="recovery">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <span slot="label">回收站 <el-tag size="mini">{{ productCount.recovery }}</el-tag></span>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </el-tab-pane>&ndash;&gt;-->
      <!--        &lt;!&ndash;        <el-tab-pane label="库存紧张" name="stock">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <span slot="label">库存紧张 <el-tag size="mini">{{ productCount.stock }}</el-tag></span>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </el-tab-pane>&ndash;&gt;-->
      <!--        &lt;!&ndash;        <el-tab-pane label="草稿箱" name="draft">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <span slot="label">草稿箱 <el-tag size="mini">{{ productCount.draft }}</el-tag></span>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </el-tab-pane>&ndash;&gt;-->
      <!--        &lt;!&ndash;        <el-tab-pane label="待审核" name="audit">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <span slot="label">待审核 <el-tag size="mini">{{ productCount.audit }}</el-tag></span>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </el-tab-pane>&ndash;&gt;-->
      <!--        &lt;!&ndash;        <el-tab-pane label="未通过" name="noAudit">&ndash;&gt;-->
      <!--        &lt;!&ndash;          <span slot="label">未通过 <el-tag size="mini">{{ productCount.noAudit }}</el-tag></span>&ndash;&gt;-->
      <!--        &lt;!&ndash;        </el-tab-pane>&ndash;&gt;-->
      <!--      </el-tabs>-->
      <el-form size="small" :inline="true" :model="searchForm">
        <!--        <el-form-item>-->
        <!--          <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">-->
        <!--            添加自营产品-->
        <!--          </el-button>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="selectProductClick()">添加分销产品
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="multiple"
            @click="delClick"
            icon="el-icon-delete"
            plain
            size="mini"
            type="danger"
          >删除
          </el-button>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.categoryId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name"
                       :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item class="fr clearfix">
          <i class="el-icon-s-fold fs-24" v-if="getShowTable===0" @click="setTableShowStatus(1)"></i>
          <i class="el-icon-menu fs-24" v-if="getShowTable===1" @click="setTableShowStatus(0)"></i>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap" v-if="getShowTable === 0">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"
                  @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="55"/>
          <el-table-column prop="productName" label="产品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.productPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="productBrand" label="品牌" width="200px"></el-table-column>
          <el-table-column prop="categoryName" label="分类" width="200px">
            <template slot-scope="scope">
                        <span>
                          {{ getShowCategoryName(scope.row.productCategoryReList) }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="spec" label="规格" width="200px">
            <template slot-scope="scope">
              {{ getSpecName(scope.row.sku) }}
            </template>
          </el-table-column>
          <el-table-column prop="highSaleCommission" show-overflow-tooltip label="销售佣金" width="160px">
            <template slot-scope="scope">
              {{ scope.row.minSaleCommission }} <span
              v-if=" scope.row.highSaleCommission &&  (scope.row.highSaleCommission !== scope.row.minSaleCommission)">- {{
                scope.row.highSaleCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="highTechnicalCommission" show-overflow-tooltip label="技术补贴" width="160px">
            <template slot-scope="scope">
              {{ scope.row.minTechnicalCommission }} <span
              v-if=" scope.row.highTechnicalCommission &&  (scope.row.highTechnicalCommission !== scope.row.minTechnicalCommission)">- {{
                scope.row.highTechnicalCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="highPlatCommission" show-overflow-tooltip label="平台补贴" width="160px">
            <template slot-scope="scope">
              {{ scope.row.minPlatCommission }} <span
              v-if=" scope.row.highPlatCommission &&  (scope.row.highPlatCommission !== scope.row.minPlatCommission)">- {{
                scope.row.highPlatCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="delClick(scope.row)" type="text" size="small"
                         v-auth="'/product/supplier/choose/delete'">
                下架商品
              </el-button>

              <el-button @click="onShareProductCodeClick(scope.row)" type="text" size="small"
                         v-auth="'/product/supplier/choose/delete'">
                分享码
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="getShowTable === 1" v-loading="loading">
        <ul class="flex f-w ">
          <li v-for="(item,index) in tableData" :key="index" style="width: 12.5%" class="p-5 file"
              @click="selectFileFunc(item,index)">
            <ratio-div :radio-value="6800/49">
              <div class="w-full h-full border absolute top-0 left-0">
                <ratio-div :radio-value="100">
                  <div class="w-full h-full absolute top-0 left-0 p-10">
                    <div class="selectedIcon" v-if="hasCheck(item.productId)">
                      <i class="el-icon-check m-l-4"></i>
                    </div>
                    <img v-img-url="item.imagePath" alt="" class="w-full h-full"/>
                    <div class="bottom-shade" @click.stop>
                      <el-button @click="delClick(item)" type="primary" size="small" class="w-full"
                                 v-auth="'/product/supplier/choose/delete'">
                        下架商品
                      </el-button>
                    </div>
                  </div>
                </ratio-div>
                <div class="line-clamp2 p-h-10">
                  {{ item.productName }}
                </div>
                <div class="p-h-10 flex a-center p-t-5">
                  <span class="fs-16 color-red">￥{{ item.productPrice }}</span>
                </div>
              </div>
            </ratio-div>
          </li>
        </ul>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <!--    <getproduct :isProduct="open_product" :dataType="1" :islist="true" @closeDialog="closeDialogFunc($event, 'add')"/>-->

    <el-dialog
      :title="productName + '分享码'" :close-on-click-modal="false"
      :visible.sync="showWxUrl"
      @close="dialogFormVisible"
      center
      width="550px"
    >
      <el-input v-model="wxUrlLink" readonly>
        <template slot="append"><span v-clipboard:copy="wxUrlLink" v-clipboard:success="copy"
                                      v-clipboard:error="onerror" style="cursor: pointer">复制</span></template>
      </el-input>
      <div class="margin-top-30 flex a-center j-center">
        <el-button @click="getProductWxUrl">重新获取</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import getproduct from '@/components/product/Product.vue'
import {mapActions, mapGetters} from 'vuex'
import RatioDiv from '../../../components/common/RatioDiv'
import AgentApi from '../../../api/agent'

export default {
  components: {getproduct, RatioDiv},
  data () {
    return {
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 16,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: '',
        categoryId: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      productCount: {},
      open_product: false,
      // 非多个禁用
      multiple: true,
      // 选中数组
      ids: [],
      productId: undefined,
      productName: undefined,
      showWxUrl: false,
      wxUrlLink: undefined
    }
  },
  computed: {
    getShowTable () {
      return this.getTableShow() || 0
    },
    ...mapGetters('common', {
      getTableShow: 'getTableShow'
    })
  },
  created () {
    /*获取列表*/
    this.getData()
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.type = self.activeName
      self.loading = true
      PorductApi.supplierConsignmentProductList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.productList.records
          self.categoryList = res.data.categoryList
          self.totalDataNumber = res.data.productList.total
          self.productCount = res.data.productCount
          self.supplierStatus = res.data.supplierStatus
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },

    /*打开添加*/
    addClick () {
      this.$router.push('/product/product/add')
    },

    /*打开编辑*/
    editClick (row) {
      console.log(row)
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'edit'
        }
      })
    },

    linkClick: function (val) {
      let self = this
      let copyText = 'pages/product/detail/detail?productId=' + val
      self.$copyText(copyText).then(function (e) {
        self.$message({
          showClose: true,
          message: '复制成功',
          type: 'success'
        })
      }, function (e) {
        self.$message({
          showClose: true,
          message: '复制失败',
          type: 'error'
        })
      })
    },
    /*打开复制*/
    copyClick (row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'copy'
        }
      })
    },
    // 多选框选中数据
    handleSelectionChange (selection) {
      this.ids = selection.map(item => item.productId)
      this.multiple = !selection.length
    },
    /*删除*/
    delClick: function (row) {
      let self = this
      let msg = ''
      let productIds = []
      if (row.productId) {
        msg = '删除后将不再分销该产品，确定删除该产品吗?'
        productIds = [row.productId]
      } else if (this.ids) {
        msg = '删除后将不再分销这些产品，确定删除这些产品吗?'
        productIds = this.ids
      }
      self
        .$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.supplierDeleteConsignmentProduct({
            productIds: productIds
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },
    /*修改状态*/
    changeStatus (item, value) {
      let self = this
      let msg = ''
      if (value == 10) {
        msg = '确认要上架该商品吗?'
      } else {
        msg = '确认要下架该商品吗?'
        if (self.activeName == 'recovery') {
          msg = '确认要移动该商品到仓库吗?'
        }
      }
      self.$confirm(msg, '提示', {
        type: 'warning'
      })
        .then(() => {
          PorductApi.changeStatus({
            productId: item.productId,
            state: value
          }).then(data => {
            self.$message({
              message: '操作成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },

    /*打开弹出层*/
    selectProductClick () {
      // this.open_product = true
      this.$router.push('/product/product/consignmentindex')
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc (e) {
      let self = this
      if (e.type != 'error') {
        // this.userInfo = e.params[0];
        // this.form.supplier.userId = e.params[0].userId;
        let productIds = []

        productIds = e.params.map(item => {
          return item.productId
        })

        let params = {
          productIds: productIds
        }
        PorductApi.addSupplierProduct(params).then(res => {

          self.$message({
            message: '添加成功',
            type: 'success'
          })
          self.getData()
        }).catch(err => {
          self.$message({
            message: err.msg || '添加失败',
            type: 'error'
          })
        })
      }
      this.open_product = false
    },
    getShowCategoryName (list) {
      let text = ''
      if (list && list.length) {
        text = list.map(item => {
          return item.categoryName
        }).join(',')
      }
      return text
    },
    getSpecName (list) {
      let text = ''
      if (list && list.length) {
        let resultList = list.filter(res => res.specName)
        if (resultList && resultList.length) {
          text = resultList[0].specName
        }
      }
      return text
    },
    hasCheck (productId) {
      let result = false
      if (this.ids.indexOf(productId) !== -1) {
        result = true
      }
      return result
    },

    /*选择图片*/
    selectFileFunc (item, index) {
      let productId = item.productId
      let indexOf = this.ids.indexOf(productId)
      if (indexOf === -1) {
        this.ids.push(productId)
      } else {
        this.ids.splice(indexOf, 1)
      }
      this.multiple = !this.ids.length
    },
    setTableShowStatus (value) {
      return this.setTableShow(value)
    },
    onShareProductCodeClick (row) {
      this.productId = row.productId
      this.productName = row.productName
      this.getProductWxUrl()
      this.showWxUrl = true
    },
    getProductWxUrl () {
      let self = this
      AgentApi.getProductCodeWxUrl({productId: this.productId}, true).then(res => {
        self.wxUrlLink = res.data
      })
    },
    dialogFormVisible () {
      this.productId = undefined
      this.productName = ''
      this.wxUrlLink = ''
    },
    copy () {
      this.$message.info('复制成功')
    },
    onerror () {
      this.$message.info('复制失败')
    },
    ...mapActions({
        setTableShow: 'common/setTableShow'
      }
    )
  }
}
</script>

<style scoped>

.selectedIcon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ff9900;
  z-index: 1;
  color: #FFFFFF;
  cursor: pointer;
}

li.file:hover .bottom-shade {
  display: block;
}

li.file .bottom-shade {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: calc(100% - 20px);
  display: none;
  transform: all 0.2s ease-out 0s;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/supplierindex.vue